import { RenderTextInput } from "app/common/renderInput";
import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";

export default function PriceCardReturn({
  values,
  handleChange,
  tripType,
  errors,
  handleBlur,
  touched,
  setFieldValue,
}) {
  const commissionCalculate = (paxType, paxBaseFare, paxTF, percentage) => {
    const baseFare = parseFloat(paxBaseFare) || 0;
    const totalFare = parseFloat(paxTF) || 0;
    const commissionPercentage = parseFloat(percentage) || 0;

    const discount = parseFloat(
      ((baseFare * commissionPercentage) / 100 || 0).toFixed(2)
    );
    const tds = parseFloat(((discount * 2) / 100 || 0).toFixed(2));
    const netFare = parseFloat((totalFare - discount + tds).toFixed(2));
    // const discount = (baseFare * commissionPercentage) / 100 || 0;
    // const tds = (discount * 2) / 100 || 0;

    // const netFare = totalFare - discount + tds;

    if (paxType == "ADULT") {
      setFieldValue("returnAdultDiscount", Number(discount).toFixed(2));
      setFieldValue("returnAdultTds", Number(tds).toFixed(2));
      setFieldValue("returnAdultNF", Number(netFare).toFixed(2));
    } else if (paxType == "CHILD") {
      setFieldValue("returnChildDiscount", Number(discount).toFixed(2));
      setFieldValue("returnChildTds", Number(tds).toFixed(2));
      setFieldValue("returnChildNF", Number(netFare).toFixed(2));
    } else {
      setFieldValue("returnInfantDiscount", Number(discount).toFixed(2));
      setFieldValue("returnInfantTds", Number(tds).toFixed(2));
      setFieldValue("returnInfantNF", Number(netFare).toFixed(2));
    }

    // return netFare;
  };
  useEffect(() => {
    if (
      values.returnAdultBF > 0 &&
      values.returnAdultTF > 0 &&
      values.returnAdultPercentage &&
      values.adults > 0
    ) {
      commissionCalculate(
        "ADULT",
        values.returnAdultBF,
        values.returnAdultTF,
        values.returnAdultPercentage
      );
    }
  }, [
    values.returnAdultBF,
    values.returnAdultTF,
    values.returnAdultPercentage,
    setFieldValue,
    values.adults > 0,
  ]);
  useEffect(() => {
    if (
      values.returnChildBF &&
      values.returnChildTF &&
      values.returnChildPercentage &&
      values.child > 0
    ) {
      commissionCalculate(
        "CHILD",
        values.returnChildBF,
        values.returnChildTF,
        values.returnChildPercentage
      );
    }
  }, [
    values.returnChildBF,
    values.returnChildTF,
    values.returnChildPercentage,
    setFieldValue,
    values.child > 0,
  ]);
  useEffect(() => {
    if (
      values.returnInfantBF &&
      values.returnInfantTF &&
      values.returnInfantPercentage &&
      values.infant > 0
    ) {
      commissionCalculate(
        "INFANT",
        values.returnInfantBF,
        values.returnInfantTF,
        values.returnInfantPercentage
      );
    }
  }, [
    values.returnInfantBF,
    values.returnInfantTF,
    values.returnInfantPercentage,
    setFieldValue,
    values.infant > 0,
  ]);
  return (
    <div>
      {values.adults > 0 && (
        <>
          <h5 className="text-primary" style={{ fontWeight: "bold" }}>
            ADULT :{" "}
          </h5>

          <Row className="form-row">
            <Col xs="12" md="6" lg={tripType == 2 ? "6" : "4"}>
              <RenderTextInput
                type="text"
                display="Base Fare"
                name={`returnAdultBF`}
                value={values?.returnAdultBF || ""}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.returnAdultBF}
                touched={touched.returnAdultBF}
                required
              />
            </Col>
            <Col xs="12" md="6" lg={tripType == 2 ? "6" : "4"}>
              <RenderTextInput
                type="text"
                display="Total Tax"
                name={`returnAdultTAF`}
                value={values?.returnAdultTAF || ""}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.returnAdultTAF}
                touched={touched.returnAdultTAF}
                required
              ></RenderTextInput>
            </Col>
            <Col xs="12" md="6" lg={tripType == 2 ? "6" : "4"}>
              <RenderTextInput
                type="text"
                display="Total Fare"
                name={`returnAdultTF`}
                value={values?.returnAdultTF || ""}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.returnAdultTF}
                touched={touched.returnAdultTF}
                required
              ></RenderTextInput>
            </Col>
            <Col xs="12" md="6" lg={tripType == 2 ? "6" : "4"}>
              <RenderTextInput
                type="text"
                display="Commission Percentage(Only Number)"
                name={`returnAdultPercentage`}
                value={values?.returnAdultPercentage || ""}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.returnAdultPercentage}
                touched={touched.returnAdultPercentage}
                required
              ></RenderTextInput>
            </Col>
            <Col xs="12" md="6" lg={tripType == 2 ? "6" : "4"}>
              <RenderTextInput
                readOnly
                type="text"
                display="Commission/Discount"
                name={`returnAdultDiscount`}
                value={values?.returnAdultDiscount || ""}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.returnAdultDiscount}
                touched={touched.returnAdultDiscount}
              ></RenderTextInput>
            </Col>
            <Col xs="12" md="6" lg={tripType == 2 ? "6" : "4"}>
              <RenderTextInput
                readOnly
                type="text"
                display="TDS Amount"
                name={`returnAdultTds`}
                value={values?.returnAdultTds || ""}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.returnAdultTds}
                touched={touched.returnAdultTds}
              ></RenderTextInput>
            </Col>
            <Col>
              <Row>
                <Col
                  xs="12"
                  md="6"
                  lg={12}
                  style={{
                    justifyContent: "flex-end",
                    display: "flex",
                  }}
                >
                  {values?.returnAdultNF > 0 && (
                    <div
                      style={{
                        fontSize: 15,
                        color: "red",
                        fontWeight: "700",
                      }}
                    >
                      Net Fare: ₹ {values?.returnAdultNF}
                    </div>
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
        </>
      )}
      {values.child > 0 && (
        <>
          <hr />
          <>
            <h5 className="text-primary" style={{ fontWeight: "bold" }}>
              CHILD :
            </h5>
            <Row className="form-row">
              <Col xs="12" md="6" lg={tripType == 2 ? "6" : "4"}>
                <RenderTextInput
                  type="text"
                  display="Base Fare"
                  name={`returnChildBF`}
                  value={values?.returnChildBF || ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.returnChildBF}
                  touched={touched.returnChildBF}
                  required
                ></RenderTextInput>
              </Col>
              <Col xs="12" md="6" lg={tripType == 2 ? "6" : "4"}>
                <RenderTextInput
                  type="text"
                  display="Total Tax"
                  name={`returnChildTAF`}
                  value={values?.returnChildTAF || ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.returnChildTAF}
                  touched={touched.returnChildTAF}
                  required
                ></RenderTextInput>
              </Col>

              <Col xs="12" md="6" lg={tripType == 2 ? "6" : "4"}>
                <RenderTextInput
                  type="text"
                  display="Total Fare"
                  name={`returnChildTF`}
                  value={values?.returnChildTF || ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.returnChildTF}
                  touched={touched.returnChildTF}
                  required
                ></RenderTextInput>
              </Col>
              <Col xs="12" md="6" lg={tripType == 2 ? "6" : "4"}>
                <RenderTextInput
                  type="text"
                  display="Commission Percentage(Only Number)"
                  name={`returnChildPercentage`}
                  value={values?.returnChildPercentage || ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.returnChildPercentage}
                  touched={touched.returnChildPercentage}
                  required
                ></RenderTextInput>
              </Col>

              <Col xs="12" md="6" lg={tripType == 2 ? "6" : "4"}>
                <RenderTextInput
                  readOnly
                  type="text"
                  display="Commission/Discount"
                  name={`returnChildDiscount`}
                  value={values?.returnChildDiscount || ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.returnChildDiscount}
                  touched={touched.returnChildDiscount}
                ></RenderTextInput>
              </Col>
              <Col xs="12" md="6" lg={tripType == 2 ? "6" : "4"}>
                <RenderTextInput
                  readOnly
                  type="text"
                  display="TDS Amount"
                  name={`returnChildTds`}
                  value={values?.returnChildTds || ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.returnChildTds}
                  touched={touched.returnChildTds}
                ></RenderTextInput>
              </Col>
              <Col>
                <Row>
                  <Col
                    xs="12"
                    md="6"
                    lg={12}
                    style={{
                      justifyContent: "flex-end",
                      display: "flex",
                    }}
                  >
                    {values?.returnChildNF > 0 && (
                      <div
                        style={{
                          fontSize: 15,
                          color: "red",
                          fontWeight: "700",
                        }}
                      >
                        Net Fare: ₹ {values?.returnChildNF}
                      </div>
                    )}
                  </Col>
                </Row>
              </Col>
            </Row>
          </>
        </>
      )}
      {values.infant > 0 && (
        <>
          <hr />
          <>
            <h5 className="text-primary" style={{ fontWeight: "bold" }}>
              INFANT :
            </h5>
            <Row className="form-row">
              <Col xs="12" md="6" lg={tripType == 2 ? "6" : "4"}>
                <RenderTextInput
                  type="text"
                  display="Base Fare"
                  name={`returnInfantBF`}
                  value={values?.returnInfantBF || ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.returnInfantBF}
                  touched={touched.returnInfantBF}
                  required
                ></RenderTextInput>
              </Col>
              <Col xs="12" md="6" lg={tripType == 2 ? "6" : "4"}>
                <RenderTextInput
                  type="text"
                  display="Total Tax"
                  name={`returnInfantTAF`}
                  value={values?.returnInfantTAF || ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.returnInfantTAF}
                  touched={touched.returnInfantTAF}
                  required
                ></RenderTextInput>
              </Col>
              <Col xs="12" md="6" lg={tripType == 2 ? "6" : "4"}>
                <RenderTextInput
                  type="text"
                  display="Total Fare"
                  name={`returnInfantTF`}
                  value={values?.returnInfantTF || ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.returnInfantTF}
                  touched={touched.returnInfantTF}
                  required
                ></RenderTextInput>
              </Col>

              <Col xs="12" md="6" lg={tripType == 2 ? "6" : "4"}>
                <RenderTextInput
                  type="text"
                  display="Commission Percentage(Only Number)"
                  name={`returnInfantPercentage`}
                  value={values?.returnInfantPercentage || ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.returnInfantPercentage}
                  touched={touched.returnInfantPercentage}
                  required
                ></RenderTextInput>
              </Col>

              <Col xs="12" md="6" lg={tripType == 2 ? "6" : "4"}>
                <RenderTextInput
                  readOnly
                  type="text"
                  display="Commission/Discount"
                  name={`returnInfantDiscount`}
                  value={values?.returnInfantDiscount || ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.returnInfantDiscount}
                  touched={touched.returnInfantDiscount}
                ></RenderTextInput>
              </Col>
              <Col xs="12" md="6" lg={tripType == 2 ? "6" : "4"}>
                <RenderTextInput
                  readOnly
                  type="text"
                  display="TDS Amount"
                  name={`returnInfantTds`}
                  value={values?.returnInfantTds || ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.returnInfantTds}
                  touched={touched.returnInfantTds}
                ></RenderTextInput>
              </Col>
              <Col>
                <Row>
                  <Col
                    xs="12"
                    md="6"
                    lg={12}
                    style={{
                      justifyContent: "flex-end",
                      display: "flex",
                    }}
                  >
                    {values?.returnInfantNF > 0 && (
                      <div
                        style={{
                          fontSize: 15,
                          color: "red",
                          fontWeight: "700",
                        }}
                      >
                        Net Fare: ₹ {values?.returnInfantNF}
                      </div>
                    )}
                  </Col>
                </Row>
              </Col>
            </Row>
          </>
        </>
      )}
    </div>
  );
}
